import ARecordingAudioPlayerControl from './index.vue';

ARecordingAudioPlayerControl.install = app => {
  app.component(ARecordingAudioPlayerControl.name, ARecordingAudioPlayerControl);
};

export default ARecordingAudioPlayerControl;
